export default __webpack_public_path__ + "static/media/logo_light.a8045b4e.png";